import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import "./i18n";
import { App } from "./app/App";
import { envError } from "./config/env";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

const root = createRoot(container);

if (envError) {
  // Plain DOM, no MUI, no i18n: a configuration this broken cannot be assumed
  // to have booted anything else, and a blank page tells a clinician nothing.
  root.render(
    <div
      style={{
        fontFamily: "Inter, system-ui, sans-serif",
        maxWidth: 640,
        margin: "15vh auto",
        padding: 24,
      }}
    >
      <h1 style={{ fontSize: 22 }}>Configuration invalide</h1>
      <p style={{ color: "#5D6678" }}>
        Cette application a été compilée avec une configuration incomplète.
        Contactez l&apos;administrateur du déploiement.
      </p>
      <pre
        style={{
          background: "#F5F7FB",
          padding: 16,
          borderRadius: 8,
          overflowX: "auto",
        }}
      >
        {envError}
      </pre>
    </div>,
  );
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
